import { DefaultRedirect } from '@components/DefaultRedirect';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/_shell/$')({ component: DefaultRedirect });
